import script from "./LinkedInPostAttachment.vue?vue&type=script&setup=true&lang=ts"
export * from "./LinkedInPostAttachment.vue?vue&type=script&setup=true&lang=ts"

import "./LinkedInPostAttachment.vue?vue&type=style&index=0&id=312c2e9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-312c2e9c"]])

export default __exports__